import { render, staticRenderFns } from "./createAtendimento.vue?vue&type=template&id=71d0859c&scoped=true&"
import script from "./createAtendimento.vue?vue&type=script&lang=js&"
export * from "./createAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./createAtendimento.vue?vue&type=style&index=0&id=71d0859c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0859c",
  null
  
)

export default component.exports